import type { MyAccess, WorkspaceCreate, WorkspaceDetail, WorkspaceSummary } from './types'

import { api } from '@/lib/api/client'


export const workspacesApi = {
  listMine: () => api.get<WorkspaceSummary[]>('/v1/workspaces'),
  create: (body: WorkspaceCreate) => api.post<WorkspaceDetail>('/v1/workspaces', body),
  get: (id: string) => api.get<WorkspaceDetail>(`/v1/workspaces/${id}`),
  update: (id: string, body: Partial<WorkspaceCreate>) =>
    api.patch<WorkspaceDetail>(`/v1/workspaces/${id}`, body),
  myAccess: (id: string) => api.get<MyAccess>(`/v1/workspaces/${id}/access`),
}
